import {
  useUserPreferences,
  useUserOnboardingEnable,
  useUserOnboardingDisable
} from "@/api";
import { Settings } from "@/components/ui/SettingsSection";
import { LoadingCircle } from "@/components/ui/loadingCircle";
import { Switch } from "@/components/ui/switch";

function OnboardingSetting() {
  const { data, error, loading } = useUserPreferences();
  const [onboardingEnable] = useUserOnboardingEnable();
  const [onboardingDisable] = useUserOnboardingDisable();

  if (error) console.error(error);

  function handleCheckedChange() {
    if (data?.onboardingDisabled) onboardingEnable();
    else onboardingDisable();
  }

  return (
    <Settings.Item
      title="Onboarding flow"
      description="Turning this off will set your start page to the App Gallery."
    >
      <Switch
        checked={!data?.onboardingDisabled}
        onCheckedChange={handleCheckedChange}
      />
      {loading && <LoadingCircle />}
    </Settings.Item>
  );
}

export default OnboardingSetting;
